import React, { Suspense, useEffect, useState, useCallback } from 'react';
import { Canvas as R3fCanvas, useThree } from '@react-three/fiber';
import { EffectComposer } from '@react-three/postprocessing';
import { useTexture } from '@react-three/drei';
import { Fluid } from '../../lib';
import { ThreeTunnel } from './tunel';
import img from '@/assets/Synto.jpg';

const Image = ({ scale }: { scale: number }) => {
    const texture = useTexture(img);
    const { viewport } = useThree();
    const [planeSize, setPlaneSize] = useState([15, 6.25]);

    const updatePlaneSize = useCallback(() => {
        const aspectRatio = 15 / 6.25;
        const width = viewport.width * scale;
        const height = width / aspectRatio;
        setPlaneSize([width, height]);
    }, [viewport.width, scale]);

    useEffect(() => {
        updatePlaneSize();
        window.addEventListener('resize', updatePlaneSize);
        return () => window.removeEventListener('resize', updatePlaneSize);
    }, [updatePlaneSize]);

    return (
        <mesh position-z={-4}>
            <planeGeometry args={[planeSize[0], planeSize[1], 256, 256]} />
            <meshStandardMaterial
                alphaMap={texture}
                transparent={true}
                alphaTest={0.5}
            />
        </mesh>
    );
};

const FluidEffect = () => {
    const planeScale = 1.8;

    return (
        <ThreeTunnel.In>
            <Image scale={planeScale} />
            <EffectComposer>
                <Fluid
                    force={1.1}
                    rainbow={true}
                    blend={3}
                    backgroundColor='#ffffff'
                    intensity={0.01}
                    radius={0.3}
                />
            </EffectComposer>
        </ThreeTunnel.In>
    );
};

const CombinedApp = () => {
    return (
        <>
            <R3fCanvas
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    height: '100vh',
                    width: '100vw',
                }}>
                <Suspense fallback={null}>
                    <ThreeTunnel.Out />
                </Suspense>
            </R3fCanvas>
            <FluidEffect />
        </>
    );
};

export default CombinedApp;
